/*
  Senpai Drip — Story pop-up
  - When it appears is set in SD Stories → "Pop-up appears":
      After a few seconds (default): springs out of the T-shirt orb once the set time has passed on the page
        (waits a little if a sheet, story, menu, cart drawer or text field is open at that moment).
      When the dock first hides: emerges in step with the scroll, as before.
    Either way: glow burst → T-shirt pops out → coin flip into the video → liquid stretch into the card.
  - Once out it floats, sits bottom-left while the dock is hidden and bounces above the T-shirt orb when it returns
  - Hides itself after SD Stories → "Hide after" (default 20s): a countdown line drains along the bottom,
    then it winds up, spins a full turn as it shrinks, coin-flips back into the tee and is sucked into the orb.
    Holding or dragging the card pauses the countdown; switching apps pauses it too.
  - Tap: full story mode opens on that video. X or swipe down: shrinks back into the orb
  - Swipe the card or orb toward the screen edge (or long-press the orb, then X): hides the orb on this page only.
    A refresh or any new page brings everything back.
  Loaded by sections/sd-stories.liquid
*/
(function(){
  'use strict';
  if (window.__sdPip) return;
  window.__sdPip = true;

  var html = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var dock = document.querySelector('[data-sd-dock]');
  var orb = document.querySelector('.sd-dock__orb:not(.sd-dock__orb--chat)');
  var pip = document.querySelector('[data-sd-pip]');

  /* coming back from the browser back-button cache: always start with the bubble showing */
  window.addEventListener('pageshow', function(e){
    if (e.persisted) html.classList.remove('sd-orb-off');
  });

  function anim(el, frames, opts){ try { return el.animate(frames, opts); } catch(e){ return null; } }
  function after(a, fn){ if (a) a.onfinish = fn; else fn(); }
  function clamp01(v){ return Math.min(Math.max(v, 0), 1); }
  function scrollTop(){ return window.scrollY || html.scrollTop || 0; }

  /* ---------- orb helpers ---------- */
  function orbOff(){ return html.classList.contains('sd-orb-off'); }
  function orbShown(){ return !!(orb && !orbOff() && orb.getClientRects().length); }
  function dockVisible(){ return !!(dock && orbShown() && !dock.classList.contains('is-hidden')); }

  var restCache = null;
  function dockShift(){
    if (!dock) return 0;
    var tf = getComputedStyle(dock).transform;
    if (!tf || tf === 'none') return 0;
    try { return new DOMMatrixReadOnly(tf).m42; } catch(e){ return 0; }
  }
  /* where the orb sits when the dock is showing, even while the dock is slid away */
  function rest(){
    if (orbShown() && !orb.hasAttribute('data-sd-busy')){
      var r = orb.getBoundingClientRect();
      restCache = { left:r.left, top:r.top - dockShift(), width:r.width, height:r.height };
    }
    return restCache || { left:14, top:window.innerHeight - 76, width:64, height:64 };
  }
  function orbSide(){ var r = rest(); return (r.left + r.width / 2) < window.innerWidth / 2 ? -1 : 1; }

  function pulseOrb(){
    if (!orbShown() || reduce) return;
    var ping = document.createElement('span');
    ping.className = 'sd-orb-ping';
    ping.setAttribute('aria-hidden', 'true');
    orb.appendChild(ping);
    setTimeout(function(){ ping.remove(); }, 1000);
    anim(orb, [{ scale:'1' }, { scale:'1.16', offset:.35 }, { scale:'.95', offset:.7 }, { scale:'1' }], { duration:640, easing:'ease-out' });
  }
  function relayout(){ try { window.dispatchEvent(new Event('resize')); } catch(e){} }

  /* ---------- hide the orb for this page (swipe off / long-press X) ---------- */
  var xBtn = null, xTimer = 0;
  function hideX(){
    clearTimeout(xTimer);
    document.removeEventListener('pointerdown', outsideX, true);
    if (xBtn){ xBtn.remove(); xBtn = null; }
  }
  function outsideX(e){
    if (xBtn && (e.target === xBtn || xBtn.contains(e.target))) return;
    hideX();
  }
  function showX(){
    if (xBtn || !orbShown()) return;
    xBtn = document.createElement('button');
    xBtn.type = 'button';
    xBtn.className = 'sd-orb-x';
    xBtn.setAttribute('aria-label', 'Hide the stories bubble');
    xBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M7 7l10 10M17 7L7 17"/></svg>';
    xBtn.style.left = (orb.offsetLeft + orb.offsetWidth - 18) + 'px';
    xBtn.style.top = (orb.offsetTop - 8) + 'px';
    orb.parentNode.appendChild(xBtn);
    xBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); removeOrb(); });
    setTimeout(function(){ document.addEventListener('pointerdown', outsideX, true); }, 0);
    xTimer = setTimeout(hideX, 4000);
    try { if (navigator.vibrate) navigator.vibrate(12); } catch(e){}
  }

  /* nothing is saved: the hide lasts until the page reloads or the shopper opens another page */
  function removeOrb(from){
    hideX();
    document.dispatchEvent(new CustomEvent('sd:orb:removed'));
    if (!orbShown() || reduce){ html.classList.add('sd-orb-off'); relayout(); return; }

    var dir = orbSide();
    orb.setAttribute('data-sd-busy', '');
    var a = anim(orb, [
      from || { translate:'0px 0px', rotate:'0deg', scale:'1', opacity:1 },
      { translate:(dir * 90) + 'px 0px', rotate:(dir * 220) + 'deg', scale:'.3', opacity:0 }
    ], { duration:440, easing:'cubic-bezier(.5,0,.9,.4)', fill:'forwards' });

    after(a, function(){
      var w = orb.offsetWidth;
      var b = anim(orb, [
        { width:w + 'px', marginLeft:'0px', marginRight:'0px' },
        { width:'0px', marginLeft:(dir > 0 ? '-12px' : '0px'), marginRight:(dir < 0 ? '-10px' : '0px') }
      ], { duration:320, easing:'cubic-bezier(.3,.7,.2,1)', fill:'forwards' });
      after(b, function(){
        html.classList.add('sd-orb-off');
        if (a) a.cancel();
        if (b) b.cancel();
        orb.removeAttribute('data-sd-busy');
        relayout();
      });
    });
  }

  function initOrb(){
    orb.style.touchAction = 'pan-y';
    orb.style.webkitTouchCallout = 'none';
    orb.addEventListener('contextmenu', function(e){ e.preventDefault(); });

    var od = null, lp = 0;
    orb.addEventListener('pointerdown', function(e){
      if (orbOff() || (e.pointerType === 'mouse' && e.button !== 0)) return;
      od = { x:e.clientX, y:e.clientY, id:e.pointerId, dx:0, moved:false, dir:orbSide() };
      clearTimeout(lp);
      lp = setTimeout(function(){ if (od && !od.moved) showX(); }, 520);
    });
    orb.addEventListener('pointermove', function(e){
      if (!od || e.pointerId !== od.id) return;
      var dx = e.clientX - od.x, dy = e.clientY - od.y;
      if (!od.moved){
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)){ clearTimeout(lp); od = null; return; }
        if (Math.abs(dx) < 8) return;
        od.moved = true;
        clearTimeout(lp); hideX();
        orb.setAttribute('data-sd-busy', '');
        orb.style.transition = 'none';
        try { orb.setPointerCapture(e.pointerId); } catch(err){}
      }
      var x = od.dir * dx > 0 ? dx : dx * .2;
      od.dx = x;
      orb.style.translate = x + 'px 0px';
      orb.style.rotate = (x * .9) + 'deg';
      orb.style.opacity = String(Math.max(.3, 1 - Math.abs(x) / 170));
    });
    function orbUp(e){
      clearTimeout(lp);
      if (!od || (e && e.pointerId !== od.id)) return;
      var d = od; od = null;
      if (!d.moved) return;
      var from = {
        translate:orb.style.translate || '0px 0px',
        rotate:orb.style.rotate || '0deg',
        scale:'1',
        opacity:parseFloat(orb.style.opacity || '1')
      };
      orb.style.translate = ''; orb.style.rotate = ''; orb.style.opacity = ''; orb.style.transition = '';
      if (d.dir * d.dx > 56){ removeOrb(from); return; }
      orb.removeAttribute('data-sd-busy');
      anim(orb, [from, { translate:'0px 0px', rotate:'0deg', scale:'1', opacity:1 }],
           { duration:460, easing:'cubic-bezier(.2,.9,.3,1.4)' });
    }
    orb.addEventListener('pointerup', orbUp);
    orb.addEventListener('pointercancel', orbUp);
  }

  /* ---------- pop-up video ---------- */
  function initPip(){
    document.body.appendChild(pip);
    var card = pip.querySelector('[data-sd-pip-card]');
    var clip = card.querySelector('.sd-pip__clip');
    var video = card.querySelector('video');
    var idx = parseInt(pip.getAttribute('data-index'), 10) || 0;

    /* when it appears: 'timer' (after DELAY) or 'dock' (first time the dock hides) */
    var MODE = pip.getAttribute('data-mode') === 'dock' ? 'dock' : 'timer';
    var DELAY = Math.max(1, parseFloat(pip.getAttribute('data-delay')) || 10) * 1000;

    /* how long it stays out before spinning back into the tee (0 = until closed) */
    var hideAttr = parseFloat(pip.getAttribute('data-hide'));
    var HIDE_MS = isNaN(hideAttr) ? 20000 : Math.max(0, hideAttr) * 1000;

    /* animation layers: lift (follows the dock) → float (idle bob) → card (morph) → face (coin flip) */
    function layer(cls){
      var d = document.createElement('div');
      d.className = cls;
      d.setAttribute('data-sd-still', '');
      return d;
    }
    var liftEl = layer('sd-pip__lift'), floatEl = layer('sd-pip__float');
    var face = layer('sd-pip__face'), tee = layer('sd-pip__tee'), burst = layer('sd-pip__burst');
    tee.setAttribute('aria-hidden', 'true');
    burst.setAttribute('aria-hidden', 'true');
    pip.insertBefore(liftEl, card);
    liftEl.appendChild(floatEl);
    floatEl.appendChild(card);
    card.insertBefore(face, clip);
    face.appendChild(clip);
    face.appendChild(tee);
    pip.insertBefore(burst, liftEl);

    /* the T-shirt that pops out is the same one spinning in the dock */
    var teeImg = orb && orb.querySelector('.sd-dock__face img, .sd-dock__orb-logo');
    var teeSrc = teeImg ? (teeImg.currentSrc || teeImg.src) : (video && video.getAttribute('data-poster'));
    if (teeSrc){
      tee.style.backgroundImage = 'url("' + teeSrc.replace(/"/g, '%22') + '"), radial-gradient(circle at 35% 28%, rgba(255,255,255,.18), rgba(14,14,16,.92) 72%)';
      tee.style.backgroundSize = teeImg ? '76% auto, cover' : 'cover, cover';
    }

    var D = 1000;
    var state = 'idle', tl = [], idleT = 0, barT = 0, loopRaf = 0, dragged = false, popT = 0;
    var side = -1, R = null, base = 0, lowBottom = 0, liftUp = 0, liftNow = 0, liftAnim = null;
    var startY = 0, dist = 260, pShow = 0, pTarget = 0;

    card.style.touchAction = 'none';

    /* ---------- auto-hide countdown ---------- */
    var hideT = 0, hideLeft = 0, hideAt = 0, held = false;

    function startHide(){
      if (!HIDE_MS || reduce === null) return;
      clearTimeout(hideT);
      held = false;
      hideLeft = HIDE_MS;
      pip.style.setProperty('--pip-hide', (HIDE_MS / 1000) + 's');
      pip.classList.remove('is-timing', 'is-held');
      void pip.offsetWidth; /* restart the drain line */
      pip.classList.add('is-timing');
      runHide();
    }
    function runHide(){
      hideAt = Date.now();
      clearTimeout(hideT);
      hideT = setTimeout(autoHide, hideLeft);
    }
    function holdHide(){
      if (!hideLeft || held) return;
      held = true;
      clearTimeout(hideT);
      hideLeft = Math.max(0, hideLeft - (Date.now() - hideAt));
      pip.classList.add('is-held');
    }
    function releaseHide(){
      if (!held) return;
      held = false;
      pip.classList.remove('is-held');
      if (state === 'out' && hideLeft > 0) runHide();
    }
    function stopHide(){
      clearTimeout(hideT);
      hideT = 0;
      hideLeft = 0;
      held = false;
      pip.classList.remove('is-timing', 'is-held');
    }
    function autoHide(){
      hideT = 0;
      hideLeft = 0;
      if (state !== 'out') return;
      closeToOrb(null, true);
    }

    /* sticky add-to-cart bars, cookie banners etc. at the bottom: stay above them */
    function bottomBar(){
      var h = 0;
      try {
        var els = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight - 6);
        for (var k = 0; k < els.length && k < 12; k++){
          var el = els[k];
          if (el === html || el === document.body || pip.contains(el) || (dock && dock.contains(el))) continue;
          var pos = getComputedStyle(el).position;
          if (pos !== 'fixed' && pos !== 'sticky') continue;
          var r = el.getBoundingClientRect();
          if (r.width > window.innerWidth * .6 && r.height < window.innerHeight * .3){
            h = Math.max(h, window.innerHeight - r.top);
          }
        }
      } catch(e){}
      return h;
    }

    /* low spot = the orb's corner (dock hidden); lifted spot = just above the orb (dock showing) */
    function place(){
      R = rest();
      side = (R.left + R.width / 2) < window.innerWidth / 2 ? -1 : 1;
      base = window.innerHeight - R.top - R.height;
      var bar = bottomBar(), floor = bar ? bar + 12 : 0;
      lowBottom = Math.max(base, floor);
      liftUp = Math.max(base + R.height + 14, floor) - lowBottom;
      pip.classList.toggle('is-right', side > 0);
      pip.style.left = side < 0 ? R.left + 'px' : 'auto';
      pip.style.right = side > 0 ? (window.innerWidth - R.left - R.width) + 'px' : 'auto';
      pip.style.bottom = lowBottom + 'px';
      burst.style.width = R.width + 'px';
      burst.style.height = R.height + 'px';
      burst.style.bottom = (base - lowBottom) + 'px';
      if (state === 'out' && liftNow > 0 && Math.abs(liftNow - liftUp) > 1){
        liftNow = liftUp;
        liftEl.style.transform = 'translateY(' + (-liftUp) + 'px)';
      }
    }

    /* damped spring curve */
    function spring(n, z, w, T){
      var wd = w * Math.sqrt(1 - z * z), out = [];
      for (var k = 0; k <= n; k++){
        var t = k / n * T;
        out.push(1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t)));
      }
      out[n] = 1;
      return out;
    }
    /* card as a circle of k × orb size, centred on the orb spot */
    function popFrame(k, W, H, sink){
      var sx = R.width / W, sy = R.height / H;
      var tx = -side * R.width * (1 - k) / 2;
      var ty = sink - R.height * (1 - k) / 2;
      return {
        transform:'translate(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px) scale(' + (sx * k).toFixed(4) + ',' + (sy * k).toFixed(4) + ')',
        borderRadius:'50% / 50%'
      };
    }
    /* px/py = 0 (circle on the orb) → 1 (full card) */
    function morphFrame(px, py, W, H, sink){
      var sx = R.width / W, sy = R.height / H;
      var qx = clamp01(px), qy = clamp01(py);
      var X = sx + (1 - sx) * px, Y = sy + (1 - sy) * py;
      var rx = 50 + (18 / W * 100 - 50) * qx, ry = 50 + (18 / H * 100 - 50) * qy;
      return {
        transform:'translate(0px,' + (sink * (1 - py)).toFixed(2) + 'px) scale(' + X.toFixed(4) + ',' + Y.toFixed(4) + ')',
        borderRadius:rx.toFixed(2) + '% / ' + ry.toFixed(2) + '%'
      };
    }

    function startMedia(){
      if (!video) return;
      if (!video.getAttribute('src') && video.getAttribute('data-src')){
        if (video.getAttribute('data-poster')) video.poster = video.getAttribute('data-poster');
        video.src = video.getAttribute('data-src');
      }
      video.muted = true;
      if (reduce){ card.classList.add('is-still'); return; }
      var p = video.play();
      if (p && p.catch) p.catch(function(){ card.classList.add('is-still'); });
    }
    function stopMedia(unload){
      if (!video) return;
      video.pause();
      if (unload){ video.removeAttribute('src'); try { video.load(); } catch(e){} }
    }

    /* ---------- the emerge timeline (scrubbed by scroll, or played on the timer) ---------- */
    function makeTimeline(){
      var W = card.offsetWidth, H = card.offsetHeight, sink = lowBottom - base + liftNow;
      var o = { duration:D, fill:'both', easing:'linear' };

      var cf = [];
      function push(f, off, op, ease){ f.offset = off; f.opacity = op; if (ease) f.easing = ease; cf.push(f); }
      push(popFrame(.3, W, H, sink), 0, 0, 'cubic-bezier(.2,.8,.3,1)');
      push(popFrame(.9, W, H, sink), .08, 1, 'cubic-bezier(.3,.6,.4,1)');
      push(popFrame(1.18, W, H, sink), .18, 1, 'cubic-bezier(.4,0,.4,1)');
      push(popFrame(.95, W, H, sink), .27, 1, 'ease-out');
      push(popFrame(1, W, H, sink), .34, 1);
      var m = 40, c = spring(m, .62, 12, .95);
      for (var j = 0; j <= m; j++){
        push(morphFrame(c[j], c[Math.min(m, j + 2)], W, H, sink), .36 + .64 * j / m, 1);
      }

      var P = 'perspective(520px) rotateY(';
      var ff = [
        { transform:P + '0deg)', offset:0 },
        { transform:P + '0deg)', offset:.3, easing:'cubic-bezier(.55,0,1,.45)' },
        { transform:P + '90deg)', offset:.41 },
        { transform:P + '-90deg)', offset:.4101, easing:'cubic-bezier(0,.55,.45,1)' },
        { transform:P + '0deg)', offset:.54 },
        { transform:P + '0deg)', offset:1 }
      ];
      var teeF = [{ opacity:1, offset:0 }, { opacity:1, offset:.41 }, { opacity:0, offset:.4101 }, { opacity:0, offset:1 }];
      var clipF = [{ opacity:0, offset:0 }, { opacity:0, offset:.41 }, { opacity:1, offset:.4101 }, { opacity:1, offset:1 }];
      var burstF = [
        { transform:'scale(.4)', opacity:0, offset:0 },
        { transform:'scale(.9)', opacity:.95, offset:.06 },
        { transform:'scale(2.6)', opacity:0, offset:.34 },
        { transform:'scale(2.6)', opacity:0, offset:1 }
      ];

      tl = [anim(card, cf, o), anim(face, ff, o), anim(tee, teeF, o), anim(clip, clipF, o), anim(burst, burstF, o)].filter(Boolean);
      tl.forEach(function(a){ a.pause(); });
    }
    function setTime(t){ tl.forEach(function(a){ a.currentTime = t; }); }

    /* auto = true: play the whole emerge on its own (timer), no scroll scrubbing */
    function emerge(auto){
      state = 'emerging';
      place();
      liftNow = 0;
      liftEl.style.transform = '';
      pip.classList.remove('is-lit', 'is-floating');
      pip.classList.add('is-launching');
      pip.hidden = false;
      startMedia();
      if (reduce){
        pip.classList.remove('is-launching');
        state = 'finishing';
        after(anim(card, [{ opacity:0 }, { opacity:1 }], { duration:220, easing:'ease-out' }), complete);
        return;
      }
      makeTimeline();
      dist = Math.min(320, Math.max(200, window.innerHeight * .34));
      startY = scrollTop();
      pShow = pTarget = 0;
      setTime(0);
      clearTimeout(idleT);
      if (auto){ autoFinish(); return; }
      idleT = setTimeout(autoFinish, 450);
    }

    /* smooth the scrub so it glides instead of jumping with each scroll event */
    function loop(){
      loopRaf = 0;
      if (state !== 'emerging') return;
      pShow += (pTarget - pShow) * .24;
      if (Math.abs(pTarget - pShow) < .003) pShow = pTarget;
      setTime(pShow * D);
      if (pShow >= .998){ complete(); return; }
      if (pShow !== pTarget) loopRaf = requestAnimationFrame(loop);
    }

    /* scrolling stopped halfway (or the timer fired): finish coming out on its own */
    function autoFinish(){
      if (state !== 'emerging') return;
      state = 'finishing';
      if (loopRaf){ cancelAnimationFrame(loopRaf); loopRaf = 0; }
      if (!tl.length){ complete(); return; }
      tl.forEach(function(a){ a.playbackRate = 1.1; a.play(); });
      after(tl[0], complete);
    }

    function complete(){
      if (state !== 'emerging' && state !== 'finishing') return;
      clearTimeout(idleT);
      if (loopRaf){ cancelAnimationFrame(loopRaf); loopRaf = 0; }
      tl.forEach(function(a){ a.cancel(); });
      tl = [];
      state = 'out';
      pip.classList.remove('is-launching');
      pip.classList.add('is-lit');
      if (!reduce){
        pip.classList.add('is-floating');
        anim(card, [
          { transform:'scale(1)' },
          { transform:'scale(1.05)', offset:.3 },
          { transform:'scale(.985)', offset:.65 },
          { transform:'scale(1)' }
        ], { duration:560, easing:'ease-out' });
      }
      syncLift();
      startHide(); /* countdown to spinning back into the tee */
    }

    /* dock came back before it was fully out: sink back into the T-shirt (dock mode only) */
    function retract(){
      if (state !== 'emerging' && state !== 'finishing') return;
      state = 'retracting';
      clearTimeout(idleT);
      if (loopRaf){ cancelAnimationFrame(loopRaf); loopRaf = 0; }
      stopMedia(false);
      if (!tl.length){ resetIdle(); return; }
      tl.forEach(function(a){ a.playbackRate = -1.8; a.play(); });
      after(tl[0], function(){
        if (state !== 'retracting') return;
        resetIdle();
        tryLaunch();
      });
    }

    function resetIdle(){
      pip.hidden = true;
      tl.forEach(function(a){ a.cancel(); });
      tl = [];
      pip.classList.remove('is-launching', 'is-lit', 'is-floating');
      card.style.transform = '';
      state = 'idle';
    }

    /* ---------- follow the dock with a springy bounce ---------- */
    function liftPx(){
      var tf = getComputedStyle(liftEl).transform;
      if (!tf || tf === 'none') return 0;
      try { return -new DOMMatrixReadOnly(tf).m42; } catch(e){ return liftNow; }
    }
    function syncLift(){
      if (state !== 'out') return;
      var to = dockVisible() ? liftUp : 0;
      if (Math.abs(to - liftNow) < 1) return;
      var from = liftPx();
      liftNow = to;
      if (liftAnim){ liftAnim.cancel(); liftAnim = null; }
      liftEl.style.transform = to ? 'translateY(' + (-to) + 'px)' : '';
      if (reduce) return;
      var up = to > from, n = 40;
      var c = up ? spring(n, .42, 15, .8) : spring(n, .6, 15, .7);
      var frames = [];
      for (var k = 0; k <= n; k++){
        var t = k / n, y = from + (to - from) * c[k];
        var st = t < .35 ? Math.sin(t / .35 * Math.PI) * (up ? .07 : .04) : 0;
        var sq = (t > .36 && t < .76) ? Math.sin((t - .36) / .4 * Math.PI) * (up ? .04 : .06) : 0;
        var sY = 1 + st - sq, sX = 1 - st * .5 + sq * .7;
        frames.push({ transform:'translateY(' + (-y).toFixed(2) + 'px) scale(' + sX.toFixed(4) + ',' + sY.toFixed(4) + ')', offset:t });
      }
      liftAnim = anim(liftEl, frames, { duration:(up ? 780 : 640), easing:'linear' });
    }

    /* ease the idle float back to rest so exit animations start clean */
    function settle(){
      if (!pip.classList.contains('is-floating')) return;
      var cur = getComputedStyle(floatEl).transform;
      pip.classList.remove('is-floating');
      if (cur && cur !== 'none') anim(floatEl, [{ transform:cur }, { transform:'none' }], { duration:220, easing:'ease-out' });
    }

    function finish(){
      stopHide();
      pip.hidden = true;
      pip.classList.remove('is-launching', 'is-lit', 'is-floating');
      state = 'done';
      clearTimeout(idleT);
      clearTimeout(popT);
      stopMedia(true);
      [card, face, tee, clip, burst, liftEl, floatEl].forEach(function(n){
        if (n.getAnimations) n.getAnimations().forEach(function(a){ a.cancel(); });
      });
      tl = [];
      liftAnim = null;
      card.style.transform = '';
      liftEl.style.transform = '';
      liftNow = 0;
    }

    /* ---------- exits ----------
       auto = true (the countdown ran out): a longer, showier trip home —
       wind-up puff, a full spin while it shrinks, video coin-flips back into the tee
       and lands upright, then the orb pops. */
    function closeToOrb(from, auto){
      if (state !== 'out') return;
      state = 'closing';
      stopHide();
      settle();
      stopMedia(false);
      var lp = liftPx();
      if (liftAnim){ liftAnim.cancel(); liftAnim = null; }
      liftEl.style.transform = lp ? 'translateY(' + (-lp) + 'px)' : '';
      if (dock) dock.classList.remove('is-hidden'); /* the tee has to be there to land in */
      if (reduce){
        after(anim(card, [{ opacity:1 }, { opacity:0 }], { duration:200, fill:'forwards' }), function(){ finish(); pulseOrb(); });
        return;
      }
      var W = card.offsetWidth, H = card.offsetHeight, sink = lowBottom - base + lp;
      var a = morphFrame(1, 1, W, H, sink), s = morphFrame(1.06, 1.06, W, H, sink), e = morphFrame(0, 0, W, H, sink), f = [];
      if (from){
        f.push({ transform:from, borderRadius:a.borderRadius, opacity:1, offset:0, easing:'cubic-bezier(.4,0,.6,1)' });
      } else {
        f.push({ transform:a.transform, borderRadius:a.borderRadius, opacity:1, offset:0, easing:'ease-out' });
        f.push({ transform:s.transform, borderRadius:s.borderRadius, opacity:1, offset:.2, easing:'cubic-bezier(.55,0,.8,.3)' });
      }
      if (auto){
        var mid = morphFrame(.42, .42, W, H, sink);
        f.push({ transform:mid.transform, borderRadius:mid.borderRadius, opacity:1, offset:.55, easing:'cubic-bezier(.5,0,.7,.4)' });
      }
      f.push({ transform:e.transform, borderRadius:e.borderRadius, opacity:1, offset:.86 });
      f.push({ transform:e.transform, borderRadius:e.borderRadius, opacity:0, offset:1 });

      var o = { duration:(auto ? 900 : 560), fill:'forwards' };
      anim(clip, [{ opacity:1, offset:0 }, { opacity:1, offset:.45 }, { opacity:0, offset:.72 }, { opacity:0, offset:1 }], o);
      anim(tee, [{ opacity:0, offset:0 }, { opacity:0, offset:.45 }, { opacity:1, offset:.72 }, { opacity:1, offset:1 }], o);

      if (auto){
        /* the content spins one full turn inside the shrinking circle and lands upright as the tee */
        var dir = side < 0 ? -1 : 1;
        anim(face, [
          { transform:'rotate(0deg) scale(1)', offset:0 },
          { transform:'rotate(0deg) scale(1)', offset:.2, easing:'cubic-bezier(.45,0,.25,1)' },
          { transform:'rotate(' + (dir * 200) + 'deg) scale(.94)', offset:.6, easing:'cubic-bezier(.3,.6,.35,1)' },
          { transform:'rotate(' + (dir * 360) + 'deg) scale(1)', offset:.86 },
          { transform:'rotate(' + (dir * 360) + 'deg) scale(1)', offset:1 }
        ], o);
      }

      after(anim(card, f, o), function(){ finish(); pulseOrb(); });
    }

    function flyAway(from){
      state = 'closing';
      stopHide();
      settle();
      stopMedia(false);
      after(anim(card, [
        { transform:from || 'none', opacity:1 },
        { transform:'translate(' + (side * window.innerWidth * .7) + 'px, 30px) rotate(' + (side * 28) + 'deg)', opacity:0 }
      ], { duration:380, easing:'cubic-bezier(.4,0,.9,.5)', fill:'forwards' }), function(){ finish(); removeOrb(); });
    }

    function fadeOut(){
      state = 'closing';
      stopHide();
      after(anim(card, [{ opacity:1 }, { opacity:0 }], { duration:200, fill:'forwards' }), finish);
    }

    function openStories(){
      if (state !== 'out') return;
      if (!window.SDStories){ if (orb) orb.click(); return; }
      state = 'opening';
      stopHide();
      var t = video && !card.classList.contains('is-still') ? video.currentTime : 0;
      stopMedia(false);
      window.SDStories.open(card, idx, {
        t:t, via:'pip',
        back:function(){
          if (dock) dock.classList.remove('is-hidden');
          var r = rest();
          return { x:r.left + r.width / 2, y:r.top + r.height / 2 };
        }
      });
      setTimeout(finish, 600);
    }

    /* ---------- buttons + drag ---------- */
    card.querySelector('[data-sd-pip-open]').addEventListener('click', function(){
      if (dragged){ dragged = false; return; }
      openStories();
    });
    card.querySelector('[data-sd-pip-x]').addEventListener('click', function(e){
      e.stopPropagation();
      if (dragged){ dragged = false; return; }
      closeToOrb();
    });
    card.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeToOrb(); });

    var d0 = null;
    card.addEventListener('pointerdown', function(e){
      dragged = false;
      if (state !== 'out') return;
      holdHide(); /* holding the card pauses the countdown */
      d0 = { x:e.clientX, y:e.clientY, dx:0, dy:0, id:e.pointerId, moved:false };
    });
    card.addEventListener('pointermove', function(e){
      if (!d0 || e.pointerId !== d0.id) return;
      d0.dx = e.clientX - d0.x; d0.dy = e.clientY - d0.y;
      if (!d0.moved){
        if (Math.abs(d0.dx) + Math.abs(d0.dy) < 9) return;
        d0.moved = true; dragged = true;
        try { card.setPointerCapture(e.pointerId); } catch(err){}
      }
      var x = side * d0.dx > 0 ? d0.dx : d0.dx * .25;
      var y = d0.dy > 0 ? d0.dy : d0.dy * .25;
      card.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + (x / 12) + 'deg)';
    });
    function release(e){
      releaseHide(); /* letting go resumes it */
      if (!d0 || (e && e.pointerId !== d0.id)) return;
      var d = d0; d0 = null;
      if (!d.moved) return;
      var from = card.style.transform;
      card.style.transform = '';
      if (side * d.dx > 64 && Math.abs(d.dx) > Math.abs(d.dy)){ flyAway(from); return; }
      if (d.dy > 56 && d.dy > Math.abs(d.dx)){ closeToOrb(from); return; }
      anim(card, [{ transform:from }, { transform:'none' }], { duration:440, easing:'cubic-bezier(.2,.9,.3,1.35)' });
    }
    card.addEventListener('pointerup', release);
    card.addEventListener('pointercancel', release);

    /* ---------- triggers ---------- */
    /* something the shopper is busy with is open: don't pop over it */
    function blocked(){
      if (orbOff() || !orbShown()) return true;
      if (html.classList.contains('sd-story-lock') || html.classList.contains('sd-so-lock') ||
          html.classList.contains('sd-hd-lock') || html.classList.contains('sd-cart-open')) return true;
      if (document.hidden) return true;
      var ae = document.activeElement;
      return !!(ae && ae.matches && ae.matches('input, textarea, select'));
    }

    /* dock mode: the first time the dock hides */
    function tryLaunch(){
      if (MODE !== 'dock' || state !== 'idle' || !dock) return;
      if (!dock.classList.contains('is-hidden')) return;
      if (blocked()) return;
      if (scrollTop() < 200) return;
      emerge();
    }

    /* timer mode: after DELAY, or as soon as nothing is in the way */
    function timerLaunch(){
      popT = 0;
      if (state !== 'idle') return;
      if (blocked()){ popT = setTimeout(timerLaunch, 1500); return; }
      emerge(true);
    }
    if (MODE === 'timer') popT = setTimeout(timerLaunch, DELAY);

    function onDock(){
      if (MODE === 'dock'){
        if (state === 'idle') tryLaunch();
        else if ((state === 'emerging' || state === 'finishing') && dockVisible()) retract();
        else if (state === 'out') syncLift();
      } else if (state === 'out'){
        syncLift();
      }
    }
    if (dock && window.MutationObserver){
      new MutationObserver(onDock).observe(dock, { attributes:true, attributeFilter:['class'] });
    }

    window.addEventListener('scroll', function(){
      if (state === 'emerging' && MODE === 'dock'){
        pTarget = clamp01((scrollTop() - startY) / dist);
        if (!loopRaf) loopRaf = requestAnimationFrame(loop);
        clearTimeout(idleT);
        idleT = setTimeout(autoFinish, 380);
      } else if (state === 'out' && !barT){
        barT = setTimeout(function(){ barT = 0; if (state === 'out') place(); }, 250);
      }
    }, { passive:true });
    window.addEventListener('resize', function(){ if (state === 'out') place(); });

    /* switching apps / tabs pauses the video and the countdown */
    document.addEventListener('visibilitychange', function(){
      if (state !== 'out') return;
      if (document.hidden){
        holdHide();
        if (video && !card.classList.contains('is-still')) video.pause();
      } else {
        releaseHide();
        if (video && !card.classList.contains('is-still')){
          var p = video.play(); if (p && p.catch) p.catch(function(){});
        }
      }
    });

    function stopForPage(){
      clearTimeout(popT);
      stopHide();
      if (state === 'idle'){ state = 'done'; return; }
      if (state === 'emerging' || state === 'finishing' || state === 'retracting'){ resetIdle(); state = 'done'; return; }
      if (state === 'out') fadeOut();
    }
    document.addEventListener('sd:stories:open', function(e){
      if (e.detail && e.detail.via === 'pip') return;
      stopForPage();
    });
    document.addEventListener('sd:stories:close', function(e){
      if (e.detail && e.detail.via === 'pip') setTimeout(pulseOrb, 540);
    });
    document.addEventListener('sd:orb:removed', stopForPage);
  }

  if (orb) initOrb();
  if (pip) initPip();
})();